import { render } from "./propertytogglededitor.vue?vue&type=template&id=bb5a7d30"
import script from "./propertytogglededitor.vue?vue&type=script&lang=js"
export * from "./propertytogglededitor.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/propertytogglededitor.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "bb5a7d30"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('bb5a7d30', __exports__)) {
    api.reload('bb5a7d30', __exports__)
  }
  
  module.hot.accept("./propertytogglededitor.vue?vue&type=template&id=bb5a7d30", () => {
    api.rerender('bb5a7d30', render)
  })

}


export default __exports__